import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../style/components/_compact-tab-navigation.scss";

interface CompactTabNavigationProps {
    activeTab: "quests" | "game";
    onTabChange: (tab: "quests" | "game") => void;
    currentGameName?: string;
}

/**
 * Compact Tab Navigation for in-game overlay mode
 * Provides 2-tab navigation between Quests & Stats and Game views
 */
const CompactTabNavigation: React.FC<CompactTabNavigationProps> = ({
    activeTab,
    onTabChange,
    currentGameName = "Game",
}) => {
    return (
        <div className="compact-tab-navigation">
            <button
                className={`compact-tab-navigation__tab ${activeTab === "game" ? "compact-tab-navigation__tab--active" : ""}`}
                onClick={() => onTabChange("game")}
                type="button"
            >
                <span className="compact-tab-navigation__tab-label">{currentGameName}</span>
            </button>

            <button
                className={`compact-tab-navigation__tab ${activeTab === "quests" ? "compact-tab-navigation__tab--active" : ""}`}
                onClick={() => onTabChange("quests")}
                type="button"
            >
                <span className="compact-tab-navigation__tab-label">Quests & Stats</span>
            </button>
        </div>
    );
};

export default CompactTabNavigation;